export const handleErrorMessage = (errorMessage, prevErrorMessage, neededErrorType) => {
  const errorType = errorMessage.type;
  const errorText = errorMessage.message;

  return errorType === neededErrorType && (prevErrorMessage.message !== errorText);
};